import { type RouteRecordRaw } from 'vue-router'

const basePath = '/recovery'
export const NRMRoutes: RouteRecordRaw[] = [
  {
    path: `${basePath}/projects`,
    name: 'NRM-NetworkRecoveryManager',
    component: () => import('@/pages/NRM/ProjectsList.vue'),
    meta: {
      title: 'Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/project/:id`,
    name: 'NRM-ViewNetworkRecoveryManagerProject',
    component: () => import('@/pages/NRM/ProjectDetails.vue'),
    meta: {
      title: 'View Project | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/projects/new`,
    name: 'NRM-AddNetworkRecoveryManagerProject',
    component: () => import('@/pages/NRM/AddProject.vue'),
    meta: {
      title: 'Add Project | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/project/:projectId/add-recovery-record`,
    name: 'NRM-AddNetworkRecoveryManagerProjectRecoveryRecord',
    component: () => import('@/pages/NRM/AddRecoveryRecord.vue'),
    meta: {
      title: 'Add Project Recovery Record | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/recovery-record/:id`,
    name: 'NRM-ViewNetworkRecoveryManagerProjectRecoveryRecord',
    component: () => import('@/pages/NRM/RecoveryRecordDetails.vue'),
    meta: {
      title: 'Project Recovery Record | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/cable-sections`,
    name: 'NRM-NetworkRecoveryManager-CableSections',
    component: () => import('@/pages/NRM/CableSectionsList.vue'),
    meta: {
      title: 'Network Recovery Manager Cable Sections',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/cable-section/:id`,
    name: 'NRM-NetworkRecoveryManager-ViewCableSection',
    component: () => import('@/pages/NRM/CableSectionDetails.vue'),
    meta: {
      title: 'View Cable Section | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/cable-sections/new`,
    name: 'NRM-NetworkRecoveryManager-AddCableSection',
    component: () => import('@/pages/NRM/AddCableSection.vue'),
    meta: {
      title: 'Add Cable Section | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/cable-sections/bulk-update`,
    name: 'NRM-NetworkRecoveryManager-BulkUpdateCableSections',
    component: () => import('@/pages/NRM/BulkUpdateCableSections.vue'),
    meta: {
      title: 'Bulk Update Cable Sections | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/dockets`,
    name: 'NRM-NetworkRecoveryManager-Dockets',
    component: () => import('@/pages/NRM/DocketsList.vue'),
    meta: {
      title: 'Network Recovery Manager Dockets',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/docket/:id`,
    name: 'NRM-NetworkRecoveryManager-ViewDocket',
    component: () => import('@/pages/NRM/DocketDetails.vue'),
    meta: {
      title: 'View Docket | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  },
  {
    path: `${basePath}/dockets/new`,
    name: 'NRM-NetworkRecoveryManager-AddDocket',
    component: () => import('@/pages/NRM/AddDocket.vue'),
    meta: {
      title: 'Add Docket | Network Recovery Manager',
      layout: 'FW',
      theme: 'NRM',
      header: 'Network Recovery Manager'
    }
  }
]

// Map for route lookups
const routeMap = new Map(NRMRoutes.map(route => [route.name, route]))

export function isNetworkRecoveryManagerRoute (routeName: string | symbol): boolean {
  const route = routeMap.get(routeName)
  return route !== undefined
}

export function isNRMProjectRoute (routeName: string): boolean {
  const route = routeMap.get(routeName)
  return route !== undefined && (route.path.startsWith(basePath + '/project') || route.path.startsWith(basePath + '/recovery-record'))
}

export function isNRMCableRoute (routeName: string): boolean {
  const route = routeMap.get(routeName)
  return route !== undefined && route.path.startsWith(basePath + '/cable')
}

export function isNRMDocketRoute (routeName: string): boolean {
  const route = routeMap.get(routeName)
  return route !== undefined && route.path.startsWith(basePath + '/docket')
}
